import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import { REHYDRATE } from 'redux-persist';

// Service Areas için async thunk
export const getSchedulingServiceAreas = createAsyncThunk(
  'scheduling/getSchedulingServiceAreas',
  async (regionId) => {
    const response = await axios.get(`/GetSchedulingServiceAreas?regionId=${regionId}`);
    return response.data;
  }
);

export const UpdateSchedulingWorkOrders = createAsyncThunk(
  'scheduling/UpdateSchedulingWorkOrders',
  async (updateData) => {
    const response = await axios.post('/UpdateSchedulingWorkOrders', updateData);
    return response.data;
  }
);

export const GetEmployeeRequest = createAsyncThunk(
  'scheduling/GetEmployeeRequest',
  async (serviceShopId) => {
    const response = await axios.get(`/GetEmployeeRequest/${serviceShopId}`);
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    return data;
  }
);

export const getSchedulingStatuses = createAsyncThunk(
  'scheduling/getSchedulingStatuses',
  async () => {
    const response = await axios.get('/GetSchedulingStatuses');
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    
    return (Array.isArray(data) ? data : []).map(item => ({
      StatusId: item.StatusId || item.Id,
      Dsc: item.Dsc,
      label: item.Dsc
    }));
  }
);

export const getSchedulingIssueTypes = createAsyncThunk(
  'scheduling/getSchedulingIssueTypes',
  async () => {
    const response = await axios.get('/GetSchedulingIssueTypes');
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    
    return (Array.isArray(data) ? data : []).map(item => ({
      IssueTypeId: item.IssueId || item.IssueTypeId || item.Id,
      Dsc: item.Dsc,
      label: item.Dsc
    }));
  }
);

export const getSchedulingWarrantyTypes = createAsyncThunk(
  'scheduling/getSchedulingWarrantyTypes',
  async () => {
    const response = await axios.get('/GetSchedulingWarrantyTypes');
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    
    return (Array.isArray(data) ? data : []).map(item => ({
      WarrantyTypeId: item.WarrantyTypeId || item.Id,
      Dsc: item.Dsc,
      label: item.Dsc
    }));
  }
);

export const searchScheduling = createAsyncThunk(
  'scheduling/searchScheduling',
  async (searchParams) => {
    try {
      const payload = {
        ...searchParams
        // NoServiceAreaDefined: typeof searchParams.NoServiceArea !== 'undefined'
        //   ? !!searchParams.NoServiceArea
        //   : null
      };
      const response = await axios.post('/SearchScheduling', payload);

      let data = response.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error('JSON parse error:', e);
        }
      }
      
      if (Array.isArray(data)) {
        return data.map(item => ({
          workOrderId: item.WorkOrderId || item.workOrderId,
          workCaseId: item.WorkCaseId || item.workCaseId || '',
          sku: item.SKU || item.sku,
          serviceShop: item.ServiceShop || item.serviceShop,
          serviceShopId: item.ServiceShopId || item.serviceShopId,
          employee: item.Employee || item.employee || item.EmployeeName,
          employeeId: item.EmployeeId || item.employeeId,
          region: item.Region || item.region || '',
          city: item.City || item.city || '',
          district: item.District || item.district || '',
          neighborhood: item.Neighborhood || item.neighborhood || '',
          address: item.Address || item.address || '',
          serviceAreaCode: item.ServiceAreaCode || item.serviceAreaCode,
          serviceArea: item.ServiceArea || item.serviceArea || `${item.ServiceAreaCode || ''} - ${item.ServiceAreaDescription || ''}`,
          statusId: item.StatusId || item.statusId,
          status: item.Status || item.status,
          appointmentDate: item.AppointmentDate || item.appointmentDate,
          issueTypeId: item.IssueTypeId || item.issueTypeId,
          issueType: item.IssueType || item.issueType || item.Issue,
          warrantyTypeId: item.WarrantyTypeId || item.warrantyTypeId,
          warrantyType: item.WarrantyType || item.warrantyType,
          // Arama için eski alanları da tut (requestSearch fonksiyonu için)
          openDate: item.OpenDate || item.openDate,
          callDate: item.CallDate || item.callDate,
          callCenterNote: item.CallCenterNote || item.callCenterNote || ''
        }));
      }
      
      return data || [];
    } catch (error) {
      console.error('Search error:', error);
      throw error;
    }
  }
);

// YENİ: Region by Employee
export const getRegionByEmployee = createAsyncThunk(
  'scheduling/getRegionByEmployee',
  async (employeeId) => {
    const response = await axios.get(`/GetRegionByEmployee/${employeeId}`);
    return response.data;
  }
);

// YENİ: Service Shop by Region - DÜZELTİLDİ
export const getServiceShopByRegion = createAsyncThunk(
  'scheduling/getServiceShopByRegion',
  async (parentServiceShopId) => {
    const response = await axios.get(`/GetServiceShopByRegion/${parentServiceShopId}`);
    
    // Boş string veya null kontrolü
    if (!response.data || response.data === '') {
      console.log('⚠️ No service shops found for region:', parentServiceShopId);
      return [];
    }
    
    // String ise parse et
    const data = typeof response.data === 'string' 
      ? JSON.parse(response.data) 
      : response.data;
      
    return Array.isArray(data) ? data : [];
  }
);

// YENİ: Employee by Service Shop - DÜZELTİLDİ
export const getEmployeeByServiceShop = createAsyncThunk(
  'scheduling/getEmployeeByServiceShop',
  async (serviceShopId) => {
    const response = await axios.get(`/GetEmployeeByServiceShop/${serviceShopId}`);
    
    // Boş string veya null kontrolü
    if (!response.data || response.data === '') {
      console.log('⚠️ No employees found for service shop:', serviceShopId);
      return [];
    }
    
    // String ise parse et
    const data = typeof response.data === 'string' 
      ? JSON.parse(response.data) 
      : response.data;
      
    return Array.isArray(data) ? data : [];
  }
);

export const getSchedulingRegion = createAsyncThunk(
  'scheduling/getSchedulingRegion',
  async () => {
    const response = await axios.get('/GetSchedulingRegion');
    return response.data;
  }
);

export const getSchedulingCity = createAsyncThunk(
  'scheduling/getSchedulingCity',
  async () => {
    const response = await axios.get('/GetSchedulingCity');
    return response.data;
  }
);

const schedulingSlice = createSlice({
  name: 'scheduling',
  initialState: {
    loading: false,
    error: '',
    serviceAreas: [],
    serviceAreaSelected: null,
    serviceShopSelected: null,
    statusSelected: [],
    statuses: [],
    issueTypeSelected: [],
    issueTypes: [],
    warrantyTypeSelected: [],
    warrantyTypes: [],
    searchResults: [],
    regionList: [],
    schedulingRegions: [],
    schedulingCities: [],
    serviceShopList: [],
    employeeList: []
  },
  reducers: {
    setServiceAreaSelected(state, action) {
      state.serviceAreaSelected = action.payload;
    },
    setServiceShopSelected(state, action) {
      state.serviceShopSelected = action.payload;
    },
    setStatusSelected(state, action) {
      const v = action.payload;
      state.statusSelected = Array.isArray(v) ? v : (v ? [v] : []);
    },
    setIssueTypeSelected(state, action) {
      const v = action.payload;
      state.issueTypeSelected = Array.isArray(v) ? v : (v ? [v] : []);
    },
    setWarrantyTypeSelected(state, action) {
      const v = action.payload;
      state.warrantyTypeSelected = Array.isArray(v) ? v : (v ? [v] : []);
    },
    clearSearchResults(state) {
      state.searchResults = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(REHYDRATE, (state, action) => {
        const scheduling = action.payload?.scheduling;
        if (scheduling) {
          // statusSelected restore
          const ss = scheduling?.statusSelected;
          if (ss !== undefined) {
            state.statusSelected = Array.isArray(ss) ? ss : (ss ? [ss] : []);
          }
          // issueTypeSelected restore
          const its = scheduling?.issueTypeSelected;
          if (its !== undefined) {
            state.issueTypeSelected = Array.isArray(its) ? its : (its ? [its] : []);
          }
          // warrantyTypeSelected restore
          const wts = scheduling?.warrantyTypeSelected;
          if (wts !== undefined) {
            state.warrantyTypeSelected = Array.isArray(wts) ? wts : (wts ? [wts] : []);
          }
        }
      })
      
      // Service Areas
      .addCase(getSchedulingServiceAreas.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getSchedulingServiceAreas.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Service Areas Error:', action.error);
      })
      .addCase(getSchedulingServiceAreas.fulfilled, (state, action) => {
        state.serviceAreas = action.payload;
        state.loading = false;
        state.error = '';
      })
      
      // Statuses
      .addCase(getSchedulingStatuses.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getSchedulingStatuses.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Statuses Error:', action.error);
      })
      .addCase(getSchedulingStatuses.fulfilled, (state, action) => {
        state.statuses = action.payload;
        state.loading = false;
        state.error = '';
      })
      
      // Issue Types
      .addCase(getSchedulingIssueTypes.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getSchedulingIssueTypes.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Issue Types Error:', action.error);
      })
      .addCase(getSchedulingIssueTypes.fulfilled, (state, action) => {
        state.issueTypes = action.payload;
        state.loading = false;
        state.error = '';
      })
      
      // Warranty Types
      .addCase(getSchedulingWarrantyTypes.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getSchedulingWarrantyTypes.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Warranty Types Error:', action.error);
      })
      .addCase(getSchedulingWarrantyTypes.fulfilled, (state, action) => {
        state.warrantyTypes = action.payload;
        state.loading = false;
        state.error = '';
      })
      
      // Search Scheduling
      .addCase(searchScheduling.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(searchScheduling.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        state.searchResults = [];
        console.error('Search Error:', action.error);
      })
      .addCase(searchScheduling.fulfilled, (state, action) => {
        state.searchResults = action.payload;
        state.loading = false;
        state.error = '';
        console.log('Search Results:', action.payload);
      })
      
      // Update Scheduling Work Orders
      .addCase(UpdateSchedulingWorkOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateSchedulingWorkOrders.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(UpdateSchedulingWorkOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      // Get Employee Request
      .addCase(GetEmployeeRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetEmployeeRequest.fulfilled, (state, action) => {
        state.employeeList = action.payload;
        state.loading = false;
      })
      .addCase(GetEmployeeRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      // YENİ: Region by Employee
      .addCase(getRegionByEmployee.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getRegionByEmployee.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Region by Employee Error:', action.error);
      })
      .addCase(getRegionByEmployee.fulfilled, (state, action) => {
        state.regionList = action.payload;
        state.loading = false;
        state.error = '';
        console.log('✅ Regions loaded:', state.regionList.length);
      })
      
      // YENİ: Service Shop by Region - DÜZELTİLDİ
      .addCase(getServiceShopByRegion.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getServiceShopByRegion.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Service Shop by Region Error:', action.error);
      })
      .addCase(getServiceShopByRegion.fulfilled, (state, action) => {
        // Artık payload zaten parse edilmiş array
        state.serviceShopList = action.payload;
        state.loading = false;
        state.error = '';
        console.log('✅ Service shops loaded:', state.serviceShopList.length, state.serviceShopList);
      })
      
      // YENİ: Employee by Service Shop - DÜZELTİLDİ
      .addCase(getEmployeeByServiceShop.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getEmployeeByServiceShop.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
        console.error('Employee by Service Shop Error:', action.error);
      })
      .addCase(getEmployeeByServiceShop.fulfilled, (state, action) => {
        // Artık payload zaten parse edilmiş array
        state.employeeList = action.payload;
        state.loading = false;
        state.error = '';
        console.log('✅ Employees loaded:', state.employeeList.length, state.employeeList);
      })
      .addCase(getSchedulingRegion.pending, (state) => { state.loading = true; })
      .addCase(getSchedulingRegion.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(getSchedulingRegion.fulfilled, (state, action) => { state.schedulingRegions = action.payload; state.loading = false; })
      .addCase(getSchedulingCity.pending, (state) => { state.loading = true; })
      .addCase(getSchedulingCity.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(getSchedulingCity.fulfilled, (state, action) => { state.schedulingCities = action.payload; state.loading = false; });
  }
});

export const {
  setServiceAreaSelected,
  setServiceShopSelected,
  setStatusSelected,
  setIssueTypeSelected,
  setWarrantyTypeSelected,
  clearSearchResults
} = schedulingSlice.actions;

export default schedulingSlice;